(() => {
  const setup = () => {
    const footerControl = document.querySelector('.tt-footer__localization');
    const floatingControl = document.querySelector('.toasty-destination-trigger');
    const footer = footerControl?.closest('footer');
    if (!footer || !floatingControl || !('IntersectionObserver' in window) || footerControl.dataset.observed) return;
    footerControl.dataset.observed = 'true';
    let footerVisible = false;
    const reconcile = () => {
      const hide = footerVisible && !floatingControl.contains(document.activeElement);
      floatingControl.toggleAttribute('data-footer-control-visible', hide);
      floatingControl.inert = hide;
    };
    const observer = new IntersectionObserver(([entry]) => {
      footerVisible = entry.isIntersecting;
      reconcile();
    }, { threshold: 0 });
    observer.observe(footer);
    floatingControl.addEventListener('blur', reconcile);
    footerControl.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      observer.disconnect(); floatingControl.removeEventListener('blur', reconcile);
      floatingControl.removeAttribute('data-footer-control-visible'); floatingControl.inert = false;
    }, { once: true });
  };
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
